import { useState } from 'react';
import { LabelV2Release } from 'types/releases';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getCurrentlyReplacingAudio,
  getDeleteReleaseLink,
  getRelease,
} from 'app/store/Releases/selectors';
import { deleteReleaseVersionEffect } from 'app/store/Releases/effects';
import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core';
import { DeleteVersionDialog } from 'app/components/Releases/DeleteVersionDialog';
import { LabelV2VersionsListComponent } from 'app/components/Releases/LabelV2VersionsList';
import { AddReleaseVersionDialog } from '../AddReleaseVersionDialog';

export interface DeleteVersion {
  versionGuid: string;
}

export const LabelV2VersionsList = () => {
  const dispatch = useAppDispatch();
  const release = useAppSelector(getRelease) as LabelV2Release;
  const currentlyReplacingAudio = useAppSelector(getCurrentlyReplacingAudio);
  const canDeleteRelease = Boolean(useAppSelector(getDeleteReleaseLink));
  const [deleteVersion, setDeleteVersion] = useState<{
    versionLabel?: string;
    versionGuid: string;
    songGuid: string;
  }>();

  const { versions = [] } = release;

  const handleDeleteVersion = ({ versionGuid }: DeleteVersion) =>
    dispatch(deleteReleaseVersionEffect({ versionGuid })).unwrap();

  return (
    <>
      <LabelV2VersionsListComponent
        loading={false}
        versions={versions}
        canDeleteRelease={canDeleteRelease}
        releaseGuid={release.guid}
        onDelete={setDeleteVersion}
        currentlyReplacingAudio={currentlyReplacingAudio}
      />
      <DeleteVersionDialog
        title="Delete Audio"
        versionLabel={deleteVersion?.versionLabel}
        onDelete={async () => {
          await handleDeleteVersion({
            versionGuid: deleteVersion?.versionGuid || '',
          });
        }}
        onClose={() => setDeleteVersion(undefined)}
      />
      <ContentContainer type={ContentContainerType.LIST}>
        <AddReleaseVersionDialog release={release} />
      </ContentContainer>
    </>
  );
};
